// Firebase connection. Used only when REACT_APP_DEMO_MODE is not "true" and the
// REACT_APP_FIREBASE_* settings are present; otherwise the app runs on mock data.
// The web config values are public identifiers (not secrets); access is enforced
// by firestore.rules and Firebase Auth.
import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFunctions, type Functions } from 'firebase/functions';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  type Firestore,
} from 'firebase/firestore';
import { DEMO_MODE } from '../config/demo';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseEnabled = !DEMO_MODE && !!config.apiKey && !!config.projectId && !!config.appId;

export const app: FirebaseApp | null = firebaseEnabled ? initializeApp(config) : null;
export const auth: Auth | null = app ? getAuth(app) : null;

// Offline cache: reception keeps working when the clinic's internet drops; changes sync later.
export const db: Firestore | null = app
  ? initializeFirestore(app, { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) })
  : null;

// Server functions run in Mumbai, next to the database.
export const fns: Functions | null = app ? getFunctions(app, 'asia-south1') : null;
